<div class="d-flex align-items-center justify-content-end text-end h-100 py-2 text-white">
  <span class="fw-bold gloss-white point-container">{{ pointsBalance$ | async | FortressCurrencyPipe : 'PTS' }}</span>
</div>
